<template>
  <div
    v-loading="loading"
    element-loading-background="transparent"
    class="chart-wrapper"
  >
    <sankey-chart
      v-if="data.length"
      :data="computedData"
      :size="{ width: 1110, height: 768 }"
      :monitor-url-params="{
        flow: filter.flow,
        startAt: filter.startAt.toISOString(),
        endAt: filter.endAt.toISOString()
      }"
    ></sankey-chart>
  </div>
</template>
<style lang="scss" scoped>
.chart-wrapper {
  width: 100%;
  height: 768px;
  overflow-x: scroll;
}
</style>
<script>
import axios from "axios";
import _ from "lodash";
import SankeyChart from "./SankeyChart.vue";

export default {
  components: { SankeyChart },
  props: {
    filter: { required: true, type: Object }
  },
  data() {
    return {
      loading: false,
      data: []
    };
  },
  computed: {
    computedData() {
      return { nodes: this.nodes, links: this.links };
    },
    links() {
      const links = [
        {
          source: "startRetro",
          target: "getTicketInfo",
          ...this.addProperties({
            event: "startRetro",
            eventResult: "success"
          })
        },
        {
          source: "getTicketInfo",
          target: "ticketNotFound",
          ...this.addProperties({
            event: "getTicketInfo",
            eventResult: "ticketNotFound"
          })
        },
        {
          source: "getTicketInfo",
          target: "ticketError",
          ...this.addProperties({
            event: "getTicketInfo",
            eventResult: "ticketError"
          })
        },
        {
          source: "getTicketInfo",
          target: "threatMetrix",
          ...this.addProperties({
            event: "getTicketInfo",
            eventResult: "success"
          })
        },
        {
          source: "threatMetrix",
          target: "invalidRetro",
          ...this.addProperties({
            event: "threatMetrix",
            eventResult: "invalidRetro"
          })
        },
        {
          source: "threatMetrix",
          target: "success",
          ...this.addProperties({
            event: "threatMetrix",
            eventResult: "success"
          })
        }
      ];

      return links;
    },
    nodes() {
      let nodes = [];
      this.links.forEach(link => {
        nodes.push({ name: link.source });
        nodes.push({ name: link.target });
      });
      nodes = _.uniqBy(nodes, "name");

      return nodes;
    }
  },
  watch: {
    filter: {
      deep: true,
      handler() {
        this.refreshData();
      }
    }
  },
  created() {
    this.refreshData();
  },
  methods: {
    refreshData() {
      this.loading = true;
      axios
        .get("api/v1/backend/logs", {
          params: {
            select: ["event", "event_result"],
            whereNull: "coupon_number",
            where: [
              `flow,=,${this.filter.flow}`,
              `created_at,>=,${this.filter.startAt.toISOString()}`,
              `created_at,<=,${this.filter.endAt.toISOString()}`
            ],
            groupBy: "event,event_result",
            count: "* as count",
            countDistinct: [
              "ffn as ffn_count",
              "ticket_number as ticket_number_count"
            ]
          }
        })
        .then(response => {
          this.data = response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    addProperties({ event, eventResult, statusClass }) {
      const item = _.find(this.data, {
        event,
        event_result: eventResult
      });

      return {
        value: item ? item.count : 0,
        properties: {
          event,
          eventResult,
          ffnCount: item ? item.ffn_count : 0,
          ticketNumberCount: item ? item.ticket_number_count : 0,
          statusClass
        }
      };
    }
  }
};
</script>
